import { isEmpty } from 'lodash'

import ApiHandler from '@/api/base'
import { FAKE_OBJECTIVE_TYPES } from '@/utils/objective-types'
import { OKR_ELEMENT_PERMISSIONS } from '@/utils/objectives'
import { uid } from '@/utils/uid'

const enrichNestedTask = ({ task, elementId, workspaceId }) => {
  const divider = '-'
  const [rootLinkedIssueId] = `${elementId}`.split(divider)
  const id = `${rootLinkedIssueId}${divider}${task.id}`
  return {
    ...task,
    id,
    uniqueId: id,
    uid: uid(),
    displayId: task.jiraIssueId || '',
    workspaceId,
    parentId: elementId,
    fitFilterCriteria: true,
    hiddenByFilter: false,
    isNestedTask: true,
    childElements: []
    // childElements: enrichNestedTasksList({
    //   tasks: task.childElements,
    //   elementId: task.id,
    //   workspaceId
    // })
  }
}

const enrichNestedTasksList = ({ tasks, elementId, workspaceId }) => {
  if (isEmpty(tasks)) {
    return [
      {
        id: uid(),
        typeId: FAKE_OBJECTIVE_TYPES.NO_NESTED_TASKS_FAKE_ROW,
        permissions: [OKR_ELEMENT_PERMISSIONS.READ],
        hiddenByFilter: false,
        fitFilterCriteria: true
      }
    ].map(task => enrichNestedTask({ task, elementId, workspaceId }))
  }
  return tasks.map(task => enrichNestedTask({ task, elementId, workspaceId }))
}

class IssuesApiHandler extends ApiHandler {
  async getIssues({ searchString, id }) {
    const { data } = await this.http.post('/getPlatformElements', {
      searchString,
      id
    })
    return data
  }

  async getIssuesByJql({ jql = '' } = {}) {
    const { data } = await this.http.post('/getIssuesByJql', {
      jql
    })
    return data
  }

  async getIssuesByWiql({ wiql = '' } = {}) {
    const { data } = await this.http.post('/getWorkItemsByWIQL', {
      wiql
    })
    return data
  }

  async getTaskNestedElements({ elementId, workspaceId, parentPlatformElementId } = {}) {
    const { data } = await this.http.post('/getNestedPlatformElements', {
      parentPlatformElementId
    })

    return enrichNestedTasksList({ tasks: data, elementId, workspaceId })
  }
}

export default IssuesApiHandler
